import Swal from 'sweetalert2';

window.sendFormV2 = function sendFormV2(form) {
    /*
    Swal.fire({
        title: 'A enviar',
        html: 'AGUARDE UM POUCO ESTÁ MESMO QUASE 😜 ... NÃO SAIA DA PAGINA<br><img src="images/loading.gif">',
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: false,
    });
     */
    let formId = form.attr('id');
    const formData = new FormData(document.getElementById(formId));
    $.ajax({
        url: $('form#' + formId).attr('action'),
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function () {
            Swal.fire({
                title: '<span style="color: #6eea05;"><b>A Enviar...</b></span>',
                html: '⚠️<b>ATENÇÃO:</b> Não saia desta página, estamos a processar os seus dados!<div style="width: 100%; display: flex; justify-content: center; align-items: center;"><img src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif?20151024034921" style="width: 150px; height: auto;"></div>',
                showConfirmButton: false,
                allowOutsideClick: false
            });
        },
        success: function (data) {
            setTimeout(function () {
                sendFormAlerts(form);
            }, 1500);
        },
        error: function (err) {
            setTimeout(function () {
                Swal.fire({
                    title: 'Erro',
                    html: '<div style="font-size: 12px !important;">Ocorreu um erro, tente novamente mais tarde.</strong></div>',
                    confirmButtonColor: '#b40413',
                    confirmButtonText: 'TENTAR NOVAMENTE >>',
                    icon: 'error'
                });
            }, 1500);
        },
        always: function (data) {
            fbq('track', 'Lead');
            sendFormAlerts(form);
        }
    });
}

$('body').on('submit', '.sendFormV2', function (e) {
    e.preventDefault();
    let form = $(this);
    form.addClass('d-none');

    sendFormV2(form);
});

function sendFormAlerts(form) {
    let button = $('#' + form.attr('id')).attr('data-button');

    if (button === undefined || button.length === 0) {
        button = 'CONTINUAR >>';
    }

    if (form.attr('data-type') === 'joinKit') {
        setTimeout(function () {
            Swal.fire({
                title: 'Parabéns!!',
                html: '<div style="font-size: 12px !important;">Registo efetuado com sucesso!<br><br>Muito em breve o seu Distribuidor Independente Herbalife Nutrition vai entrar em contacto consigo!</div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    } else if (form.attr('data-type') === 'whatsapp') {
        setTimeout(function () {
            Swal.fire({
                title: 'WhatsApp',
                html: '<div style="font-size: 12px !important;">As suas definições de envio de mensagens por WhatsApp foram atualizadas com sucesso!</div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    } else if (form.attr('data-type') === 'fitwoman') {
        setTimeout(function () {
            Swal.fire({
                title: 'Parabéns!!',
                html: '<div style="font-size: 12px !important;">Registo efetuado com sucesso!<br><br>Só faltam 1 passo para ter acesso às Ofertas e aos links das 2 Sessões  Informativas!</div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    } else if (form.attr('data-type') === 'fitwoman_2') {
        setTimeout(function () {
            Swal.fire({
                title: 'Parabéns!!',
                html: '<div style="font-size: 12px !important;">Registo efetuado com sucesso!<br><br>O teu <b>Coach</b> vai entrar em contacto contigo com a maior brevidade possível, para que ainda consigas vagas para entrar no <b>Fit Woman</b>.<br><br>Se ainda não fizeste a nossa <b>Avaliação Online GRATUITA</b>, faz agora!</div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    } else if (form.attr('data-type') === 'fitman') {
        setTimeout(function () {
            Swal.fire({
                title: 'Parabéns!!',
                html: '<div style="font-size: 12px !important;">Registo efetuado com sucesso!<br><br>Só faltam 1 passo para ter acesso às Ofertas e aos links das 2 Sessões  Informativas!</div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    } else if (form.attr('data-type') === 'fitman_2') {
        setTimeout(function () {
            Swal.fire({
                title: 'Parabéns!!',
                html: '<div style="font-size: 12px !important;">Registo efetuado com sucesso!<br><br>O teu <b>Coach</b> vai entrar em contacto contigo com a maior brevidade possível, para que ainda consigas vagas para entrar no <b>Fit Man</b>.<br><br>Se ainda não fizeste a nossa <b>Avaliação Online GRATUITA</b>, faz agora!</div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    } else if (form.attr('data-type') === 'webinar') {
        if (parseInt(form.attr('data-is-open')) === 1) {
            window.location.replace(form.attr('data-redirect'));
        } else {
            Swal.fire({
                title: 'Parabéns!!',
                html: '<div style="font-size: 12px !important;">Registo efetuado com sucesso!<br><br>Infelizmente este webinar já terminou.<br><br>Mas poderá assistir à GRAVAÇÃO do Webinar enquanto está disponível.<br><br><b>PRESSIONE NO BOTÃO CONTINUAR >></b></div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            })
        }
    } else if (form.attr('data-type') === 'dynamic-apn') {
        setTimeout(function () {
            Swal.fire({
                title: 'Parabéns!!',
                html: '<div style="font-size: 12px !important;">Registo efetuado com sucesso!<br><br>Muito em breve o teu Distribuidor Independente Herbalife, vai entrar em contato contigo!</div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: 'CONTINUAR >>',
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    } else {
        setTimeout(function () {
            Swal.fire({
                title: 'Enviado',
                html: '<div style="font-size: 12px !important;">Parabéns o seu registo foi efetuado com sucesso!<br><br>Dentro de alguns minutos vai receber um Email nosso, com o <span style="color: #31b404"><strong>REMETENTE</strong></span>: <strong>Nutrição HBL</strong> caso não o encontre na caixa de entrada procure-o na caixa de <strong>Promoções</strong>, <strong>Spam</strong> pode ter ido para lá por engano, e coloque-o em Remetente Seguro!<br><br><strong>Já temos tudo preparado para si!</strong></div>',
                confirmButtonColor: '#31b404',
                confirmButtonText: button,
                icon: 'success'
            }).then(function () {
                if (form.attr('data-redirect') !== '') {
                    window.location.replace(form.attr('data-redirect'));
                }
            });
        }, 1500);
    }
}

$('body').on('click', '.rift_form_submit', function () {
    let formId;
    let form;
    form = $(this).closest('form');
    if (!form.valid) return false
    form.addClass('d-none');

    sendForm(form.attr('id'));

    let button;
    button = $('#' + form.attr('id')).attr('data-button');

    setTimeout(function () {
        Swal.fire({
            title: 'Enviado',
            html: '<div style="font-size: 12px !important;">Parabéns o seu registo foi efetuado com sucesso!<br><br>Dentro de alguns minutos vai receber um Email nosso, com o <span style="color: #31b404"><strong>REMETENTE</strong></span>: <strong>Nutrição HBL</strong> caso não o encontre na caixa de entrada procure-o na caixa de <strong>Promoções</strong>, <strong>Spam</strong> pode ter ido para lá por engano, e coloque-o em Remetente Seguro!<br><br><strong>Já temos tudo preparado para si!</strong></div>',
            confirmButtonColor: '#31b404',
            confirmButtonText: button,
            icon: 'success'
        }).then(function () {
            window.location.replace(form.attr('data-redirect'));
        });
    }, 1500);
});
